export default "__VITE_ASSET__6c1a4cf3__"